(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    if (!document.querySelector("[data-ushare-partners]")) return;
    var root = document;

    var map = {
      hospitals: "hospitals",
      referral: "referral",
      "referral-partners": "referral",
      travel: "travel",
      "travel-services": "travel"
    };

    function hashTab() {
      return map[(location.hash || "").replace("#", "")] || "";
    }

    function setTab(tab, scroll) {
      tab = map[tab] || "hospitals";
      root.querySelectorAll("[data-ww-tab]").forEach(function (btn) {
        var on = btn.getAttribute("data-ww-tab") === tab;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.querySelectorAll("[data-panel]").forEach(function (panel) {
        var on = panel.getAttribute("data-panel") === tab;
        panel.classList.toggle("is-visible", on);
      });
      root.querySelectorAll("[data-ww-wrap]").forEach(function (wrap) {
        wrap.hidden = wrap.getAttribute("data-ww-wrap") !== tab;
      });
      var hash = "#" + tab;
      if ((location.hash || "") !== hash && history.replaceState) {
        history.replaceState(null, "", hash);
      }
      if (scroll) {
        var panel = root.querySelector('[data-panel="' + tab + '"]');
        if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    root.querySelectorAll("[data-ww-tab]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setTab(btn.getAttribute("data-ww-tab"), true);
      });
    });

    window.addEventListener("hashchange", function () {
      var tab = hashTab();
      if (tab) setTab(tab, true);
    });

    var initial = hashTab() || "hospitals";
    setTab(initial, Boolean(hashTab()));
  });
})();
